import React from 'react';
import { CTAButton } from './CTAButton';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Hero() {
  return <section className="pt-8 pb-16 md:pt-16 md:pb-24 px-6 md:px-8 bg-cream overflow-hidden" data-id="element-62">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-63">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} className="order-2 md:order-1" data-id="element-64">
          <div className="inline-block px-3 py-1 mb-6 rounded-full bg-terracotta/10 text-terracotta text-sm font-medium tracking-wide" data-id="element-65">
            FOR WEEKS 6–12
          </div>

          <h1 className="font-serif text-4xl md:text-6xl font-medium text-brown leading-[1.1] mb-6" data-id="element-66">
            You're Not Lazy. <br data-id="element-67" />
            <span className="italic text-terracotta" data-id="element-68">You're Nap‑Trapped.</span>
          </h1>

          <p className="font-sans text-lg md:text-xl text-brown-light leading-relaxed mb-8 max-w-lg" data-id="element-69">
            A 7-day plan to get your body back — without sleep training, crying
            it out, or waiting for "later."
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-70">
            <CTAButton text="Get the Plan" onClick={() => {
            const el = document.getElementById('pricing');
            if (el) el.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-71" />
          </div>

          <p className="text-sm text-brown-light/80 flex items-center gap-2" data-id="element-72">
            <Check className="w-4 h-4 text-sage" data-id="element-73" /> Instant download
            <Check className="w-4 h-4 text-sage" data-id="element-74" /> Phone-first
            <Check className="w-4 h-4 text-sage" data-id="element-75" /> Works today
          </p>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="order-1 md:order-2 relative" data-id="element-76">
          <div className="aspect-[4/3] md:aspect-square relative rounded-2xl overflow-hidden shadow-2xl shadow-brown/10" data-id="element-77">
            <img src="https://cdn.magicpatterns.com/uploads/bvVpfz2nJa3fkvhrScu2eG/image_1.png" alt="The Nap-Trapped Reset ebook on a bed with a sleeping baby" className="w-full h-full object-cover" data-id="element-78" />
            <div className="absolute inset-0 bg-gradient-to-t from-brown/20 to-transparent pointer-events-none" data-id="element-79" />
          </div>

          {/* Floating Badge */}
          <div className="absolute -bottom-6 -left-6 md:bottom-8 md:-left-8 bg-cream p-4 rounded-xl shadow-xl max-w-[200px] hidden md:block rotate-[-2deg]" data-id="element-80">
            <p className="font-serif text-brown text-sm italic leading-tight" data-id="element-81">
              "The first plan that actually understands I can't just 'put them
              down'."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}